import type { LessonClassId } from '~/@entities/LessonClass'
import type {
  LessonClassChallengeResponse,
  LessonClassChallengeSettingStatusRequest,
  LessonClassChallengeSettingUpdateRequest,
  LessonClassChallengesResponse,
  UpsertChallengeSettingResponse,
} from '~/api-spec/__generated__/main'
import { httpClient, type RequestMeta } from '~/http/client'

import {
  adaptAssignedChallenges,
  adaptLessonClassChallengeSettings,
  adaptSavedLessonClassChallengeSetting,
} from './adapters'
import type {
  AssignedChallenge,
  LessonClassChallengeSetting,
  SavedLessonClassChallengeSetting,
} from './schemas'

export const getAssignedChallenges = async (meta?: RequestMeta): Promise<AssignedChallenge[]> => {
  const body = await httpClient().get<LessonClassChallengesResponse>('/lesson-classes/challenges', {
    meta,
  })
  return adaptAssignedChallenges(body).challenges
}

/***************** 반의 챌린지 설정 *****************/
// 이 컨트롤러는 CommonResponse 봉투 없이 본문을 바로 낸다.

export type LessonClassChallengeSettingBody = LessonClassChallengeSettingUpdateRequest
export type LessonClassChallengeSettingStatusBody = LessonClassChallengeSettingStatusRequest

export const getLessonClassChallengeSettings = async (
  lessonClassId: LessonClassId,
  meta?: RequestMeta,
): Promise<LessonClassChallengeSetting[]> =>
  adaptLessonClassChallengeSettings(
    await httpClient().get<LessonClassChallengeResponse>(
      `/lesson-classes/${lessonClassId}/challenges`,
      { meta },
    ),
  )

export const saveLessonClassChallengeSetting = async (
  lessonClassId: LessonClassId,
  setting: LessonClassChallengeSettingBody,
  meta?: RequestMeta,
): Promise<SavedLessonClassChallengeSetting> =>
  adaptSavedLessonClassChallengeSetting(
    await httpClient().post<UpsertChallengeSettingResponse>(
      `/lesson-classes/${lessonClassId}/setting-challenges`,
      setting,
      { meta },
    ),
  )

export const updateLessonClassChallengeSettingStatus = async (
  setting: LessonClassChallengeSettingStatusBody,
  meta?: RequestMeta,
): Promise<void> => {
  await httpClient().patch('/lesson-classes/settings/status', setting, { meta })
}
